(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/deposit/assets/tracking/shared-tracking.js') >= 0) return;  svs.modules.push('/components/accountservices-react/deposit/assets/tracking/shared-tracking.js');
"use strict";


const {
  SWISH,
  APPLEPAY,
  BANKCARD
} = svs.accountservicesReact.deposit.constants.paymentTypes;
const getTrackingPaymentType = paymentType => {
  var _paymentType$toLowerC;
  let pt = paymentType === null || paymentType === void 0 || (_paymentType$toLowerC = paymentType.toLowerCase()) === null || _paymentType$toLowerC === void 0 ? void 0 : _paymentType$toLowerC.trim();
  if (pt) {
    switch (pt) {
      case SWISH:
        pt = 'Swish';
        break;
      case BANKCARD:
        pt = 'CC';
        break;
      case APPLEPAY:
        pt = 'CC ApplePay';
        break;
      default:
        pt = paymentType;
    }
  } else {
    pt = 'Unknown Payment Type';
  }
  return pt;
};

const trackSuccess = async (paymentType, amount) => new Promise(resolve => {
  svs.components.analytics.trackEvent({
    category: 'Deposits',
    action: 'Deposit Success',
    opt_label: getTrackingPaymentType(paymentType),
    opt_value: parseInt(amount, 10) || 0
  }, () => {
    resolve();
  });
});

const trackFailure = async (paymentType, errorCode) => new Promise(resolve => {
  svs.components.analytics.trackEvent({
    category: 'Deposits',
    action: 'Deposit Failure',
    opt_label: getTrackingPaymentType(paymentType),
    opt_value: errorCode
  }, () => {
    resolve();
  });
});
svs.accountservicesReact.deposit.tracking.sharedTracking = {
  trackSuccess,
  trackFailure,
  getTrackingPaymentType
};

 })(window);